import WeekRow from "./month/WeekRow";
import ActualDays from "./month/ActualDays";
import { Week } from "./week/Week";
import PropTypes from "prop-types";

const DefaultTimesheet = ({
  date,
  projects,
  occupations,
  activities,
  tasks,
  createActivity,
  createOccupation,
  setReportedHours,
  setApprovedHours,
  actualLogs,
  updateActuals,
  changeContextMenu,
  copyLogRequest,
  changeTooltip,
  copyEnabled,
  showWeekendLogs,
  actualsZoom,
}) => {
  const projectFor = (log) => projects.find((project) => project.id === log.project_id);
  const getHeight = (log) => (log.duration / 60) * 62;

  return actualsZoom === "month" ? (
    <div
      style={{
        position: "relative",
        left: 0,
        marginLeft: 30,
        marginRight: 30,
        width: "100%",
        overflowY: "auto",
        top: 10,
      }}
    >
      <WeekRow showWeekendLogs={showWeekendLogs} weekStartDate={date} />

      <ActualDays
        changeContextMenu={changeContextMenu}
        projects={projects}
        date={date}
        occupations={occupations}
        activities={activities}
        createActivity={createActivity}
        createOccupation={createOccupation}
        setReportedHours={setReportedHours}
        setApprovedHours={setApprovedHours}
        actualLogs={actualLogs}
        updateActuals={updateActuals}
        changeTooltip={changeTooltip}
        copyEnabled={copyEnabled}
        copyLogRequest={copyLogRequest}
        showWeekendLogs={showWeekendLogs}
      />
    </div>
  ) : (
    <Week
      startDate={date}
      logs={actualLogs}
      projects={projects}
      tasks={tasks}
      createActivity={createActivity}
      createOccupation={createOccupation}
      activities={activities}
      occupations={occupations}
      updateActuals={updateActuals}
      changeContextMenu={changeContextMenu}
      copyLogRequest={copyLogRequest}
      showWeekendLogs={showWeekendLogs}
      changeTooltip={changeTooltip}
      copyEnabled={copyEnabled}
      variant="actuals"
    />
  );
};

DefaultTimesheet.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  projects: PropTypes.array.isRequired,
  occupations: PropTypes.array.isRequired,
  activities: PropTypes.array.isRequired,
  createActivity: PropTypes.func.isRequired,
  createOccupation: PropTypes.func.isRequired,
  setReportedHours: PropTypes.func.isRequired,
  setApprovedHours: PropTypes.func.isRequired,
  actualLogs: PropTypes.array.isRequired,
  updateActuals: PropTypes.func.isRequired,
  changeContextMenu: PropTypes.func.isRequired,
  copyLogRequest: PropTypes.func.isRequired,
  changeTooltip: PropTypes.func.isRequired,
  copyEnabled: PropTypes.bool.isRequired,
  showWeekendLogs: PropTypes.bool.isRequired,
  account: PropTypes.object.isRequired,
  actualsZoom: PropTypes.string.isRequired,
};

export default DefaultTimesheet;
